import { OysterIcon } from "@oysterhr/icons"
import { ToastVariation } from "./types"

export const ICON_MAP: {
  [key in ToastVariation]: OysterIcon
} = {
  error: "WarningCircle",
  info: "InfoCircle",
  primary: "WarningOctagon",
  success: "CheckCircle",
  warning: "WarningTriangle",
}
